import { useState } from 'react'
import { useLocalStorage } from '..'
import { trackEvent } from '../../utils/dtmHelpers'
import { sendGoogleTagEvent } from '../../utils/google-tag-manager-helpers'

const useProgrammeList = ({
  name,
  image,
  programmeGuid,
} = {}) => {
  const [removeguid, setRemoveGuid] = useState('')
  const [localProgrammes, setLocalProgrammes] = useLocalStorage('localProgrammes', {}, removeguid)
  const inStore = (guid = programmeGuid) => (Object.keys(localProgrammes).includes(guid))
  const removeProgramme = (guid = programmeGuid) => {
    trackEvent('removeFromMylist', { my_list_prog: programmeGuid })
    sendGoogleTagEvent('remove_from_mylist', { item: guid })
    setRemoveGuid(programmeGuid)
    const newProgrammes = { ...localProgrammes }
    delete newProgrammes[guid]
    setLocalProgrammes(newProgrammes)
  }

  const addProgramme = (programme = { name, image, programmeGuid }) => {
    trackEvent('addMyList', { my_list_prog: programmeGuid })
    sendGoogleTagEvent('add_to_mylist', { item: programmeGuid })
    sendGoogleTagEvent('add_to_wishlist', { item: programmeGuid })
    setRemoveGuid('')
    const newProgrammes = { ...localProgrammes }
    newProgrammes[programmeGuid] = programme
    setLocalProgrammes(newProgrammes)
  }

  // not the most elegant setup but now we can just
  // include the programme in the handler params
  const handleClick = e => (programme = { name, image, programmeGuid }) => () => {
    const addedAt = Date.now()
    return inStore(programme.programmeGuid)
      ? removeProgramme(programme.programmeGuid)
      : addProgramme({ ...programme, addedAt })
  }

  return {
    inStore,
    handleClick: handleClick(),
    localProgrammes,
  }
}

export default useProgrammeList
